module.exports = __webpack_public_path__ + "static/Dfyn-70c06b8df4437fd5bacfb52675fcf7c6.svg";